import React from 'react';
import toast from 'react-hot-toast';
import {
  Box,
  Card,
  CardContent,
  Chip,
  IconButton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography
} from '@mui/material';

import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import { getClientSettlementDocument } from '../../../services/request';
import { useParameterizedQuery } from 'react-fetching-library';
import PDFPreviewModal from '../../employee/order/order-details/tabs/DocumentAndNotificationsTab/PDFPreviewModal';

export const InvoicesCard = ({ orderData }) => {
  const invoices = orderData.invoices || [];

  const [previewUrl, setPreviewUrl] = React.useState(null);
  const { query, loading } = useParameterizedQuery(getClientSettlementDocument);

  const handleDownloadSettlementDocument = async (id, fileName, preview = false) => {
    const params = { invoice_id: id };
    const { payload, error, loading } = await query(id, params);
    if (!error && !loading) {
      if (preview) {
        setPreviewUrl(window.URL.createObjectURL(payload));
      } else {
        const url = window.URL.createObjectURL(payload);
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.style = 'display: none';
        a.href = url;
        a.download = `${fileName}.pdf`;
        a.click();
        window.URL.revokeObjectURL(url);
      }

    } else {
      toast.error('Nie udało się pobrać pliku');
    }
  };

  return (
    <Card
      sx={{
        borderRadius: 4,
        boxShadow: theme => theme.shadows[2]
      }}
    >
      <CardContent sx={{ p: 5 }}>
        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          mb={4}
        >
          <Box
            sx={{
              width: 56,
              height: 56,
              borderRadius: 2,
              bgcolor: 'primary.lighter',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <ReceiptLongOutlinedIcon color="primary" />
          </Box>

          <Typography
            variant="h4"
            fontWeight={700}
          >
            Faktury i paragony
          </Typography>
        </Stack>

        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  <strong>Numer</strong>
                </TableCell>

                <TableCell>
                  <strong>Typ</strong>
                </TableCell>

                <TableCell>
                  <strong>Data wystawienia</strong>
                </TableCell>

                <TableCell>
                  <strong>Kwota</strong>
                </TableCell>

                <TableCell>
                  <strong>Status</strong>
                </TableCell>

                <TableCell align="right">
                  <strong>Akcje</strong>
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {invoices.map(invoice => {
                const isPaid =
                  Number(
                    invoice.outstanding?.parsedValue || 0
                  ) === 0;

                return (
                  <TableRow key={invoice.id}>
                    <TableCell>
                      {invoice.number}
                    </TableCell>

                    <TableCell>
                      {invoice.type_display}
                    </TableCell>

                    <TableCell>
                      {invoice.issue_date
                        ? new Date(
                          invoice.issue_date
                        ).toLocaleDateString(
                          'pl-PL'
                        )
                        : '-'}
                    </TableCell>

                    <TableCell>
                      {invoice.total_gross_value} zł
                    </TableCell>

                    <TableCell>
                      <Chip
                        size="small"
                        color={
                          isPaid
                            ? 'success'
                            : 'warning'
                        }
                        label={
                          isPaid
                            ? 'Opłacona'
                            : 'Nieopłacona'
                        }
                      />
                    </TableCell>

                    <TableCell align="right">
                      <Stack
                        direction="row"
                        spacing={1}
                        justifyContent="flex-end"
                      >
                        <Tooltip title="Podgląd">
                          <IconButton
                            color="primary"
                            size="small"
                            onClick={() => handleDownloadSettlementDocument(
                              invoice.id,
                              invoice.number,
                              true
                            )
                            }
                          >
                            <VisibilityOutlinedIcon />
                          </IconButton>
                        </Tooltip>

                        <Tooltip title="Pobierz">
                          <IconButton
                            color="primary"
                            size="small"
                            onClick={() => handleDownloadSettlementDocument(
                              invoice.id,
                              invoice.number,
                              false
                            )}
                          >
                            <DownloadOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      </Stack>
                    </TableCell>
                  </TableRow>
                );
              })}

              {!invoices.length && (
                <TableRow>
                  <TableCell
                    colSpan={6}
                    align="center"
                  >
                    Brak dokumentów rozliczeniowych
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
      {previewUrl !== null ? <PDFPreviewModal url={previewUrl} handleClose={() => setPreviewUrl(null)}/> : null}
    </Card>
  );
};
